Ext.define('SA.view.BootErrorPopup', {
    alias: 'widget.boot-error-popup',
    extend: 'Ext.Component',

    autoShow: true,
    cls: 'sa-boot-error-popup',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    html: [
        '<svg class="sa-boot-error-popup-warning-icon"><use href="#sa-icon-warning"></use></svg>',
        '<div class="sa-boot-error-popup-text">',
            '<b>SimplyAnalytics has encountered an unknown error and cannot load your account. ',
            'Please email support@simplyanalytics.com immediately so we can look into this issue ',
            'and get this solved for you as soon as possible.</b>',
            '<p>We apologize for the inconvenience.</p>',
        '</div>'
    ]
});